import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { API_URL } from '@app/core/services/api-token';

@Service({ autoProvided: false })
export class APIInterceptor implements HttpInterceptor {
  token!: string | undefined;
  private readonly router = inject(Router);
  private readonly apiUrl = inject(API_URL);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const update: { url: string; headers?: HttpHeaders } = { url: `${this.apiUrl}${req.url}` };
    const apiReq = req.clone(update);

    return next.handle(apiReq).pipe(
      catchError(error => {
        if (error.status === HttpStatusCode.Forbidden) {
          globalThis.localStorage.clear();
          this.router.navigate(['/blocked']);
        }

        // HTTP/2/3 does not have reason phrases any more, so map the status code to the standard status text here
        return throwError(() => new HttpErrorResponse({ ...error, statusText: `${HttpStatusCode[error.status]}` }));
      }),
    );
  }
}
